/* Adds a selected recommendation through Dawn's existing section-rendering flow. */
if (!customElements.get('he-cart-upsells')) {
  customElements.define('he-cart-upsells', class extends HTMLElement {
    constructor() {
      super();
      this.addEventListener('change', (event) => {
        if (!event.target.matches('select[name="id"]')) return;
        const form = event.target.form;
        const option = event.target.selectedOptions[0];
        form.querySelector('.he-upsell-price').textContent = option.dataset.price;
        form.elements.quantity.value = option.dataset.quantity || 1;
        form.querySelector('button').disabled = false;
      });
      this.addEventListener('submit', (event) => this.add(event));
    }

    async add(event) {
      const form = event.target.closest('.he-upsell-form');
      if (!form) return;
      event.preventDefault();
      const drawer = this.closest('cart-drawer');
      if (drawer.dataset.heAdding === 'true' || !form.elements.id.value) return;
      const button = form.querySelector('button');
      const error = form.querySelector('.he-upsell-error');
      const controls = [...drawer.querySelectorAll('button, input, select')];
      const disabledStates = controls.map((control) => control.disabled);
      const body = new FormData(form);
      body.append('sections', drawer.getSectionsToRender().map((section) => section.id).join(','));
      body.append('sections_url', window.location.pathname);
      drawer.dataset.heAdding = 'true';
      controls.forEach((control) => { control.disabled = true; });
      button.textContent = 'Adding…';
      error.hidden = true;
      // Restore focus to a stable element if the recommended card disappears.
      drawer.setActiveElement(document.getElementById('cart-icon-bubble'));
      let added = false;
      try {
        const response = await fetch(window.routes.cart_add_url, {
          method: 'POST', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body,
        });
        const state = await response.json();
        if (!response.ok || state.status) throw new Error(state.description || 'Unable to add this item. Please try again.');
        added = true;
        if (!state.sections?.['cart-drawer'] || !state.sections?.['cart-icon-bubble']) {
          const url = new URL(window.location.href);
          url.searchParams.set('sections', 'cart-drawer,cart-icon-bubble');
          const refreshed = await fetch(url);
          if (!refreshed.ok) throw new Error('Cart refresh failed');
          state.sections = await refreshed.json();
          if (!state.sections['cart-drawer'] || !state.sections['cart-icon-bubble']) throw new Error('Cart refresh failed');
        }
        drawer.classList.remove('is-empty');
        drawer.renderContents(state);
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', productVariantId: body.get('id'), cartData: state });
        drawer.querySelector('.drawer__close')?.focus();
      } catch (cause) {
        error.textContent = added
          ? 'Item added, but the cart could not refresh. Please refresh this page before adding it again.'
          : (cause.message || 'Unable to add this item. Please try again.');
        error.hidden = false;
      } finally {
        delete drawer.dataset.heAdding;
        controls.forEach((control, index) => { control.disabled = disabledStates[index]; });
        button.textContent = 'Add';
        if (added && error.isConnected && !error.hidden) button.disabled = true;
        if (!added && button.isConnected) button.focus();
      }
    }
  });
}
